import React from "react";
import { asArray, asText } from "../briefModel";
import "./_brief-overview.scss";

// The brief's first tab: what to watch first (handoff 34 §4 ① ② ⑥) — the
// headline, the watch-outs in the order given (never re-sorted) and, past a
// year's first quarter, what carried over from last quarter. All plain text,
// rendered as text with its line breaks kept.
const BriefOverview = ({ brief }) => {
  const headline = asText(brief?.headline);
  const watchOuts = asArray(brief?.watch_outs).filter(
    (w) => w && (asText(w.point) || asText(w.evidence)),
  );
  const continuity = asText(brief?.continuity);

  if (!headline && !watchOuts.length && !continuity) {
    return (
      <div className="scb-empty-state">
        The brief has no summary. See the other tabs.
      </div>
    );
  }

  return (
    <div className="qokr-brief-overview">
      {headline ? (
        <div className="qokr-brief-overview__headline">{headline}</div>
      ) : null}

      {watchOuts.length ? (
        <section className="qokr-brief-section">
          <h3 className="qokr-brief-section__title">Watch-outs</h3>
          <ol className="qokr-brief-overview__watch">
            {watchOuts.map((item, index) => (
              <li key={index}>
                <span className="qokr-brief-overview__num">{index + 1}</span>
                <div>
                  {asText(item.point) ? (
                    <strong>{asText(item.point)}</strong>
                  ) : null}
                  {asText(item.evidence) ? (
                    <p>{asText(item.evidence)}</p>
                  ) : null}
                </div>
              </li>
            ))}
          </ol>
        </section>
      ) : null}

      {continuity ? (
        <section className="qokr-brief-section">
          <h3 className="qokr-brief-section__title">From last quarter</h3>
          <p className="qokr-brief-section__text">{continuity}</p>
        </section>
      ) : null}
    </div>
  );
};

export default BriefOverview;
